import CityPageTemplate from "../city-template/CityPageTemplate";
import { lubbockConfig } from "./data";

export default function LubbockPage() {
  return <CityPageTemplate config={lubbockConfig} />;
}